export const essay_schema = {
  essayId: '',
  promptId: '',
  userId: '',
  progress: 0,
  status: 'To Do',
  brainstorms: {},
  outlines: [],
  outlinesFixed: false,
  title: '',
  titleFixed: false,
  draftTitle: '',
  draft: '',
  revisionVersion: {},
  essayText: '',
  loadProgress: 0,
  assessment: {},
  prompt: '',
  shortPrompt: '',
  level: 0,
  primaryType: '',
  secondaryType: '',
  category: '',
  illustration: '',
  tags: [],
  thumbnailUrl: '',
  minWordCount: 0,
};
